module.exports = __webpack_public_path__ + "img/A9.dae15c3a.svg";